import React from 'react';
import PropTypes from 'prop-types';

export default class GReCaptcha extends React.PureComponent {
    handleResponse = (response) => {
        this.props.onResponse(response);
    };

    componentDidMount() {
        window.grecaptcha.render(this.grecaptchaContainer, {
                sitekey:  process.env.REACT_APP_RECAPTCHA_PUBLIC,
                callback: this.handleResponse
            }
        );
    }

    render() {
        return <div className='recaptcha' ref={element => {
            this.grecaptchaContainer = element;
        }}/>
    }
}

GReCaptcha.propTypes = {
    onResponse: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/app/GReCaptcha.js